import AddInventoryItemDrawer from '../../../modals/inventory/AddInventoryItemDrawer';
import EditInventoryItemDrawer from '../../../modals/inventory/EditInventoryItemDrawer';
import DeleteInventoryItemModal from '../../../modals/inventory/DeleteInventoryItemModal';
import BulkDeleteInventoryConfirmDialog from '../../../modals/inventory/BulkDeleteInventoryConfirmDialog';
import InventoryImportHistoryDrawer from '../../../modals/inventory/InventoryImportHistoryDrawer';
import InventoryExportHistoryDrawer from '../../../modals/inventory/InventoryExportHistoryDrawer';
import InventoryCommittedImportModal from '../../../modals/inventory/InventoryCommittedImportModal';
import type { InventoryListPageModel } from './useInventoryListPage';

export function InventoryListModals({ page }: { page: InventoryListPageModel }) {
    const {
        isAddDrawerOpen,
        onAddDrawerClose,
        handleRequestImport,
        isEditDrawerOpen,
        onEditDrawerClose,
        selectedItemId,
        locationsData,
        locationIds,
        deleteTargetItem,
        handleDeleteRequest,
        isDeleteModalOpen,
        handleDeleteModalClose,
        handleItemDeleted,
        handleViewExistingItem,
        selectedItemIds,
        isBulkDeleteOpen,
        onBulkDeleteClose,
        handleBulkDeleteConfirm,
        isBulkDeleteLoading,
        isImportHistoryOpen,
        onImportHistoryClose,
        handleImportHistorySelectJob,
        isExportHistoryOpen,
        onExportHistoryClose,
        highlightExportId,
        historyOpenedFromOptions,
        handleHistoryBackToOptions,
        isOptionsSwapInstant,
        committedModalJobId,
        setCommittedModalJobId,
    } = page;
    const onHistoryBack = historyOpenedFromOptions ? handleHistoryBackToOptions : undefined;

    const locations = locationsData?.locations ?? [];
    const defaultLocationId =
        locationIds !== 'all' && locationIds.length === 1 ? locationIds[0] : '';

    return (
        <>
            <AddInventoryItemDrawer
                isOpen={isAddDrawerOpen}
                onClose={onAddDrawerClose}
                locations={locations}
                defaultLocationId={defaultLocationId}
                onViewExistingItem={handleViewExistingItem}
                onImport={handleRequestImport}
            />
            <EditInventoryItemDrawer
                isOpen={isEditDrawerOpen}
                onClose={onEditDrawerClose}
                inventoryItemId={selectedItemId}
                onDelete={handleDeleteRequest}
            />
            <DeleteInventoryItemModal
                isOpen={isDeleteModalOpen}
                onClose={handleDeleteModalClose}
                item={deleteTargetItem}
                onDeleted={handleItemDeleted}
            />
            <BulkDeleteInventoryConfirmDialog
                isOpen={isBulkDeleteOpen}
                onClose={onBulkDeleteClose}
                itemCount={selectedItemIds.size}
                onConfirm={handleBulkDeleteConfirm}
                isLoading={isBulkDeleteLoading}
            />
            <InventoryImportHistoryDrawer
                isOpen={isImportHistoryOpen}
                onClose={onImportHistoryClose}
                onSelectJob={handleImportHistorySelectJob}
                onBack={onHistoryBack}
                instantMotion={isOptionsSwapInstant}
            />
            <InventoryExportHistoryDrawer
                isOpen={isExportHistoryOpen}
                onClose={onExportHistoryClose}
                highlightExportId={highlightExportId}
                onBack={onHistoryBack}
                instantMotion={isOptionsSwapInstant}
            />
            <InventoryCommittedImportModal
                isOpen={!!committedModalJobId}
                onClose={() => setCommittedModalJobId(null)}
                jobId={committedModalJobId}
            />
        </>
    );
}
